"use strict";
/**
 * RNG-based validator.
 *
 * @author Louis-Dominique Dubeau
 * @license MPL 2.0
 * @copyright Mangalam Research Center for Buddhist Languages
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "9.0.1";
var patterns_1 = require("./patterns");
exports.eventsToTreeString = patterns_1.eventsToTreeString;
exports.Event = patterns_1.Event;
exports.Grammar = patterns_1.Grammar;
exports.GrammarWalker = patterns_1.GrammarWalker;
exports.BasePattern = patterns_1.BasePattern;
exports.RefError = patterns_1.RefError;
var conversion_1 = require("./conversion");
exports.convertRNGToPattern = conversion_1.convertRNGToPattern;
exports.makeResourceLoader = conversion_1.makeResourceLoader;
var write_1 = require("./json-format/write");
exports.writeTreeToJSON = write_1.writeTreeToJSON;
var read_1 = require("./json-format/read");
exports.readTreeFromJSON = read_1.readTreeFromJSON;
var ename_1 = require("./ename");
exports.EName = ename_1.EName;
var errors_1 = require("./errors");
exports.AttributeNameError = errors_1.AttributeNameError;
exports.AttributeValueError = errors_1.AttributeValueError;
exports.ChoiceError = errors_1.ChoiceError;
exports.ElementNameError = errors_1.ElementNameError;
exports.ValidationError = errors_1.ValidationError;
var default_name_resolver_1 = require("./default_name_resolver");
exports.DefaultNameResolver = default_name_resolver_1.DefaultNameResolver;
var name_patterns_1 = require("./name_patterns");
exports.BaseName = name_patterns_1.Base;
exports.Name = name_patterns_1.Name;
exports.NameChoice = name_patterns_1.NameChoice;
exports.NsName = name_patterns_1.NsName;
exports.AnyName = name_patterns_1.AnyName;
//  LocalWords:  rng Mangalam Dubeau MPL RNG constructTree validator
//# sourceMappingURL=validate.js.map